import { render } from "./GolfResults.vue?vue&type=template&id=46650b32&scoped=true"
import script from "./GolfResults.vue?vue&type=script&lang=js"
export * from "./GolfResults.vue?vue&type=script&lang=js"

import "./GolfResults.vue?vue&type=style&index=0&id=46650b32&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0a0cda5bfc5ca6053-1/assemble-sports/universityoftasmania-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46650b32"]])

export default __exports__